import React from "react";
import { FaGithub, FaCamera, FaCircleNotch, FaPython } from "react-icons/fa";

import { GiTeacher } from "react-icons/gi";
import { GrLanguage } from "react-icons/gr";

const Skills = () => {
  const [header] = React.useState({
    subHeading: "My Skills",
  });
  const [state] = React.useState([
    {
      id: 1,
      icon: <FaGithub className="commonIcons" />,
      heading: "FrontEnd Developer",
      text:
        "I know html5, css, scss, bootstrap, javascript jquery, react, react hooks, redux, vuejs, github",
      fade: "fade-right",
    },
    {
      id: 2,
      icon: <FaCamera className="commonIcons" />,
      heading: "Video and Photo editor",
      text:
        "I know Shortcut, Kinemaster, Photoshop, Filmora I had to learn them when I was controlling youtube, instagram, telegram channels and I think they are very useful of web developers",
      fade: "fade",
    },
    {
      id: 3,
      icon: <FaPython className="commonIcons" />,
      heading: "Other languages",
      text:
        "I know C++ (I have learned in my university), I know python and its framework Django (I studied independently from youtube and other documentaions), I have basic php concepts",
      fade: "fade-left",
    },
    {
      id: 4,
      icon: <GrLanguage className="commonIcons" />,
      heading: "Languages",
      text:
        "I know extra international languages, they are english and russian. I think my english level is uppermidiate, and russian level is intermidiate and also I can usterstand this words in these languages and I can speak fluently",
      fade: "fade-right",
    },
    {
      id: 5,
      icon: <FaCircleNotch className="commonIcons" />,
      heading: "Blogger",
      text: (
        <span>
          I like to share my knowledge to others, so I have a channel called
          <a
            href="https://www.youtube.com/channel/UCOlJa25ucIiZiMc1xyNv-2Q"
            target="blank"
          >
            'Motivator and Changer'
          </a>
          in YouTube and a channel called
          <a
            href="https://web.telegram.org/#/im?p=@BOYLARvaMASHHURLAR"
            target="blank"
          >
            'Boylar va Mashhurlar'
          </a>
        </span>
      ),
      fade: "fade-left",
    },

    // {
    //   id: 6,
    //   icon: <FcSportsMode className="commonIcons" />,
    //   heading: "Sport",
    //   text:
    //     "Football is my favourite sport game, I like it, especially doing tricks and I know chess, tennis, swimming, basketball, valleyball",
    //   fade: "fade",
    // },
    {
      id: 6,
      icon: <GiTeacher className="commonIcons" />,
      heading: "Teacher",
      text:
        "Explaining things is very interesting for me, so I love to explain and teach, I can teach programming languages c++, python, javascript and math, english physics",
      fade: "fade-right",
    },
  ]);
  return (
    <div className="skills">
      <div className="container">
        <div className="skillsHeader">
          <div className="skillsCommon">
            <h1>{header.subHeading}</h1>
            <div className="common"></div>
          </div>

          <div className="skillsRow" data-aos="fade-up">
            {state.map((info) => (
              <div className="skillBox" data-aos="fade-up" key={info.id}>
                <div className="skillInner">
                  {info.icon}
                  <h2 className="skillHeader">{info.heading}</h2>
                  <div className="skillInfo">{info.text}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
